/* MV Sortiment assets/mv-sortiment.pk.js - Paket P-3 - 2026-10-08
 *
 * Komplettpakete-Seite (sections/mv-paket-uebersicht.liquid, Wurzel [data-mv-pk]): Filter nach Geraetetyp und Paket ohne
 * Neuladen. Inhaber 08.10.2026 zu /collections/komplettpakete: "Hier sind keine Komplettpakete?" (Doku _docs/p3-pakete.md).
 *  1. Karten [data-mv-pk-karte] tragen data-mv-pk-typ und data-mv-pk-paket; Chips [data-mv-pk-filter="typ|paket"] mit
 *     data-mv-pk-wert ("alle" oder ein Wert) sind Schaltflaechen mit aria-pressed (Muster mv-hilfe-hub).
 *  2. Zustand {typ, paket} aus der Adresse (?typ=, ?paket=; erster Wert, ohne Gross-/Kleinschreibung; Werte ohne Chip
 *     gelten als "alle"). Jeder Klick schreibt ihn per history.replaceState zurueck: "alle" entfernt den Parameter,
 *     fremde Parameter (z. B. preview_theme_id) und der Anker bleiben unveraendert.
 *  3. Nicht passende Karten bekommen hidden; der Zaehler [data-mv-pk-zaehler] (role status) nennt die Zahl ("1 Paket",
 *     "n Pakete"); ohne Treffer zeigt [data-mv-pk-leer] den Knopf [data-mv-pk-zuruecksetzen] (danach Fokus auf "Alle").
 *  4. Chips, die mit der Auswahl der anderen Gruppe keine Karte haetten, sind aria-disabled (nie "Alle", nie der
 *     gedrueckte); ein Klick darauf aendert nichts.
 *  5. Paket LZ-1c (2026-10-25, _docs/lz1-c-cls-schrift.md, Variante A): die Leiste [data-mv-pk-werkzeug] steht
 *     serverseitig sichtbar da, ihre Chips sind bis zum Start disabled (pk.css schwaecht sie ab, ohne Layoutwirkung).
 *     Das Skript gibt die Chips frei, wendet den Zustand an und setzt dann data-mv-pk-bereit an Leiste und Wurzel;
 *     hidden an der Leiste (aeltere Fassung der Sektion) entfernt es nur noch als Rueckfall.
 * Delegation auf document (click), shopify:section:load startet eine neu geladene Sektion, pageshow aus dem Cache
 * stellt den Zustand der Adresse wieder her. Waechter window.__mvSortimentPk. Kein Netz, kein Speicher. Laedt allein und
 * in beliebiger Reihenfolge als Teil von assets/mv-sortiment.js (_build/konkat.sh). Unter Node (Tests) liefert die Datei
 * nur die reinen Funktionen ueber module.exports. Datei ASCII; sichtbare Texte nur der Zaehler.
 */
;(function () {
  'use strict';

  var VERSION = '2026-10-25.1';
  var WURZEL = '[data-mv-pk]';
  var ALLE = 'alle';
  var GRUPPEN = ['typ', 'paket'];
  var TEXT = {
    eins: '1 Paket',
    mehrere: '{n} Pakete'
  };

  // ===========================================================================================
  // Reine Logik (ohne window und document; unter Node per module.exports pruefbar)
  // ===========================================================================================

  function text(x) {
    return x === null || x === undefined ? '' : String(x).trim();
  }

  // Suchteil in Paare zerlegen: "?a=1&b=2" -> [["a", "1"], ["b", "2"]]; kaputte Kodierung faellt weg
  function paare(suche) {
    var s = text(suche);
    if (s.charAt(0) === '?') s = s.slice(1);
    var out = [];
    s.split('&').forEach(function (teil) {
      if (!teil) return;
      var i = teil.indexOf('=');
      var k = i === -1 ? teil : teil.slice(0, i);
      var w = i === -1 ? '' : teil.slice(i + 1);
      try {
        k = decodeURIComponent(k.replace(/\+/g, ' '));
        w = decodeURIComponent(w.replace(/\+/g, ' '));
      } catch (e) {
        return;
      }
      out.push([k, w]);
    });
    return out;
  }

  // Zustand aus dem Suchteil: je Gruppe der erste Wert, wenn es dazu einen Chip gibt (erlaubt[gruppe]), sonst "alle"
  function zustandAus(suche, erlaubt) {
    var z = { typ: ALLE, paket: ALLE };
    var gesehen = {};
    paare(suche).forEach(function (p) {
      var g = p[0];
      if (GRUPPEN.indexOf(g) === -1 || gesehen[g]) return;
      gesehen[g] = true;
      var w = text(p[1]).toLowerCase();
      var liste = (erlaubt && erlaubt[g]) || [];
      if (liste.indexOf(w) !== -1) z[g] = w;
    });
    return z;
  }

  // Passt eine Karte ({typ, paket}) zum Zustand?
  function passt(karte, z) {
    return (z.typ === ALLE || karte.typ === z.typ) && (z.paket === ALLE || karte.paket === z.paket);
  }

  function anzahl(karten, z) {
    var n = 0;
    for (var i = 0; i < karten.length; i++) if (passt(karten[i], z)) n++;
    return n;
  }

  // Ergaebe der Wert dieser Gruppe (die andere Gruppe bleibt) mindestens eine Karte?
  function moeglich(karten, z, gruppe, wert) {
    var neu = { typ: z.typ, paket: z.paket };
    neu[gruppe] = wert;
    return anzahl(karten, neu) > 0;
  }

  // Neuer Suchteil: typ und paket gesetzt ("alle" entfernt), fremde Parameter roh und in ihrer Reihenfolge
  function suchteil(suche, z) {
    var s = text(suche);
    if (s.charAt(0) === '?') s = s.slice(1);
    var teile = s.split('&').filter(function (teil) {
      if (!teil) return false;
      var k = teil.split('=')[0];
      try {
        k = decodeURIComponent(k.replace(/\+/g, ' '));
      } catch (e) {
        return true;
      }
      return GRUPPEN.indexOf(k) === -1;
    });
    GRUPPEN.forEach(function (g) {
      if (z[g] && z[g] !== ALLE) teile.push(g + '=' + encodeURIComponent(z[g]));
    });
    return teile.length ? '?' + teile.join('&') : '';
  }

  function zaehlerText(n) {
    return n === 1 ? TEXT.eins : TEXT.mehrere.replace('{n}', String(n));
  }

  var logik = {
    VERSION: VERSION,
    ALLE: ALLE,
    GRUPPEN: GRUPPEN,
    paare: paare,
    zustandAus: zustandAus,
    passt: passt,
    anzahl: anzahl,
    moeglich: moeglich,
    suchteil: suchteil,
    zaehlerText: zaehlerText
  };

  // Exportfenster nur unter Node (kein window): Tests laden die Datei als Skript mit module-Objekt
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (typeof module === 'object' && module && module.exports) module.exports = logik;
    return;
  }

  // ===========================================================================================
  // Browser
  // ===========================================================================================

  if (window.__mvSortimentPk) return;
  var api = window.__mvSortimentPk = { version: VERSION, logik: logik };
  var MV = window.__mvSortiment = window.__mvSortiment || {};
  if (!MV.pk) MV.pk = api;

  function alsListe(x) {
    return Array.prototype.slice.call(x || []);
  }

  function karten(wurzel) {
    return alsListe(wurzel.querySelectorAll('[data-mv-pk-karte]')).map(function (el) {
      return { el: el, typ: text(el.getAttribute('data-mv-pk-typ')), paket: text(el.getAttribute('data-mv-pk-paket')) };
    });
  }

  function chips(wurzel) {
    return alsListe(wurzel.querySelectorAll('[data-mv-pk-filter]'));
  }

  // Erlaubte Werte je Gruppe = Werte der Chips (ohne "alle")
  function erlaubt(wurzel) {
    var e = { typ: [], paket: [] };
    chips(wurzel).forEach(function (c) {
      var g = c.getAttribute('data-mv-pk-filter');
      var w = text(c.getAttribute('data-mv-pk-wert'));
      if (e[g] && w && w !== ALLE) e[g].push(w);
    });
    return e;
  }

  function zustandVon(wurzel) {
    return {
      typ: wurzel.getAttribute('data-mv-pk-typ-aktiv') || ALLE,
      paket: wurzel.getAttribute('data-mv-pk-paket-aktiv') || ALLE
    };
  }

  function anwenden(wurzel, z) {
    var liste = karten(wurzel);
    var n = 0;
    liste.forEach(function (k) {
      var ok = passt(k, z);
      if (k.el.hidden === ok) k.el.hidden = !ok;
      if (ok) n++;
    });
    chips(wurzel).forEach(function (c) {
      var g = c.getAttribute('data-mv-pk-filter');
      if (GRUPPEN.indexOf(g) === -1) return;
      var w = text(c.getAttribute('data-mv-pk-wert')) || ALLE;
      var an = z[g] === w;
      c.setAttribute('aria-pressed', an ? 'true' : 'false');
      if (!an && w !== ALLE && !moeglich(liste, z, g, w)) c.setAttribute('aria-disabled', 'true');
      else c.removeAttribute('aria-disabled');
    });
    var zaehler = wurzel.querySelector('[data-mv-pk-zaehler]');
    var neu = zaehlerText(n);
    if (zaehler && zaehler.textContent !== neu) zaehler.textContent = neu;
    var leer = wurzel.querySelector('[data-mv-pk-leer]');
    if (leer) leer.hidden = n > 0;
    wurzel.setAttribute('data-mv-pk-typ-aktiv', z.typ);
    wurzel.setAttribute('data-mv-pk-paket-aktiv', z.paket);
  }

  function adresse(z) {
    try {
      var l = window.location;
      var neu = l.pathname + suchteil(l.search, z) + l.hash;
      if (neu !== l.pathname + l.search + l.hash) window.history.replaceState(window.history.state, '', neu);
    } catch (e) {
      /* ohne History-API bleibt die Adresse */
    }
  }

  function initWurzel(wurzel) {
    var werkzeug = wurzel.querySelector('[data-mv-pk-werkzeug]');
    // LZ-1c: Sperre der Chips aufheben (disabled im Markup bis zum Start)
    chips(wurzel).forEach(function (c) {
      if (c.hasAttribute('disabled')) c.removeAttribute('disabled');
    });
    anwenden(wurzel, zustandAus(window.location.search, erlaubt(wurzel)));
    // Rueckfall fuer eine Sektion mit hidden an der Leiste (vor LZ-1c): erst nach anwenden, damit bei einem Fehler
    // keine leere Leiste stehen bleibt
    if (werkzeug && werkzeug.hidden) werkzeug.hidden = false;
    // LZ-1c: Leiste bedienbar - Signal fuer pk.css (Abschwaechung der Chips endet)
    if (werkzeug) werkzeug.setAttribute('data-mv-pk-bereit', '');
    wurzel.setAttribute('data-mv-pk-bereit', '');
  }

  // Wurzeln im Bereich (auch der Bereich selbst, z. B. eine neu geladene Sektionshuelle)
  function wurzelnIn(bereich) {
    var liste = bereich && typeof bereich.querySelectorAll === 'function' ? alsListe(bereich.querySelectorAll(WURZEL)) : [];
    if (bereich && typeof bereich.matches === 'function' && bereich.matches(WURZEL)) liste.unshift(bereich);
    return liste;
  }

  function initBereich(bereich) {
    wurzelnIn(bereich).forEach(initWurzel);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || typeof t.closest !== 'function') return;
    var knopf = t.closest('[data-mv-pk-filter], [data-mv-pk-zuruecksetzen]');
    if (!knopf) return;
    var wurzel = knopf.closest(WURZEL);
    if (!wurzel) return;
    var z;
    if (knopf.hasAttribute('data-mv-pk-zuruecksetzen')) {
      z = { typ: ALLE, paket: ALLE };
    } else {
      var g = knopf.getAttribute('data-mv-pk-filter');
      if (GRUPPEN.indexOf(g) === -1 || knopf.getAttribute('aria-disabled') === 'true') return;
      z = zustandVon(wurzel);
      z[g] = text(knopf.getAttribute('data-mv-pk-wert')) || ALLE;
    }
    anwenden(wurzel, z);
    adresse(z);
    if (knopf.hasAttribute('data-mv-pk-zuruecksetzen')) {
      var alle = wurzel.querySelector('[data-mv-pk-filter="typ"][data-mv-pk-wert="' + ALLE + '"]');
      if (alle && typeof alle.focus === 'function') alle.focus();
    }
  });

  // Theme-Editor: neu geladene Sektion starten
  document.addEventListener('shopify:section:load', function (e) {
    initBereich(e.target);
  });

  // Zurueck aus dem Cache: Zustand wieder aus der Adresse
  window.addEventListener('pageshow', function (e) {
    if (e && e.persisted) initBereich(document);
  });

  api.initialisieren = function () {
    initBereich(document);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', api.initialisieren);
  else api.initialisieren();
})();
